<script lang="ts" setup>
import { useTranslation } from '@hfc/ui-core';
import { useUrlHelper } from '@/page/infrastructure/composition/useUrlHelper';

const { getBaseUrl } = useUrlHelper();
const { t } = useTranslation();
</script>

<template>
  <div class="md:px-12">
    <h4 class="text-blue text-xl font-bold pb-6 md:pb-10">{{ t('coveredCalifornia.questions.afterApplication.tab') }}</h4>
    <p class="text-gray-500 text-left pb-7">{{ t('coveredCalifornia.questions.afterApplication.p1') }}</p>
    <p class="text-gray-500 text-left pb-7">{{ t('coveredCalifornia.questions.afterApplication.p2') }}</p>
    <p class="text-gray-500 text-left pb-4">{{ t('coveredCalifornia.questions.afterApplication.p3') }}</p>
    <ul class="text-gray-500 text-left list-disc pl-5 space-y-2">
      <li v-html="t('coveredCalifornia.questions.afterApplication.item1', { documentProofsUrl: getBaseUrl('/covered-california/document-proofs') })"></li>
      <li>{{ t('coveredCalifornia.questions.afterApplication.item2') }}</li>
    </ul>
  </div>
</template>
